module.exports = __webpack_public_path__ + "img/57_lg.16d1f37e.jpg";